import Vue from "vue";
import VueRouter from "vue-router";
import Vuex from "vuex";
import AppPanelist from "@/components/application/AppPanelist.vue";
import AppCommunity from "@/modules/MemberApp/components/index.vue";
import {ValidationProvider, ValidationObserver} from "vee-validate/dist/vee-validate.full";
import {RoutesPanelist} from "@/routes-panelist.js";
import mixins from "@/mixins.js";
import store from "@/root-store/index.ts";
import "vue-json-pretty/lib/styles.css";
import Api from "@/api.js";
import VuetifyLight from "@/vuetify-light.js";
import moment from "moment";
import "@/firebaseInstallServiceWorker.js";
import "@/bugsnag.js";
import '../css/app.css';
import '../css/loading.css';
import VueGtag from "vue-gtag";

/** Progressive Web App */
window.addEventListener("beforeinstallprompt", (event) => {
    // This prevents browsers from asking to install SN as a PWA.
    // Also, commented part of the webmanifest to make the PWA not installable.
    // @see app/Http/Controllers/WebManifestController.php
    // @see https://developer.mozilla.org/en-US/docs/Web/Progressive_web_apps/How_to/Trigger_install_prompt
    event.preventDefault();

    // @TODO: We need to let admins to choose to enable/disable this functionality.
});

window.moment = moment;

/** Create global instance of axios **/
window.axios = Api;

Vue.component('AppPanelist', AppPanelist);
Vue.component('AppCommunity', AppCommunity);

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

// Global mixins
Vue.mixin(mixins);

// Plugins
Vue.use(VueGtag, {
    bootstrap: false
});
Vue.use(VueRouter);
Vue.use(Vuex);

Vue.config.productionTip = false;

new Vue({
    vuetify: VuetifyLight,
    router: new VueRouter({
        mode: 'history',
        routes: RoutesPanelist
    }),
    store: new Vuex.Store(store)
}).$mount('#app');